import styled from "styled-components";

const B1 = {
  fontFamily: "Mark For MC Narrow W00 Light",
  fontStyle: "normal",
  fontWeight: 350,
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.5px",
  color: "#CCCCCC"
};

const HEADER = {
  fontFamily: "Mark For MC Narrow W00 Light",
  fontStyle: "normal",
  fontSize: "24px",
  lineHeight: "32px",
  color: "#FFF",
  textAlign: "center"
};

const rowSpaceBetween = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center"
};

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: #000000;
  padding-top: 24px;
`;

export const Intro = styled.section`
  background-color: #282827;
  margin: 0px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 16px;
  gap: 40px;
  border-radius: 6px;

  h1 {
    ${HEADER}
  }

  p,
  a {
    ${B1}
    text-align: center;
  }

  a {
    text-decoration: underline;
    cursor: pointer;
  }

  img {
    height: 74px;
    margin: auto;
  }
`;

export const ViewBalance = styled.div`
  background-color: #282827;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 22.5px 0;
  border-radius: 6px;
  margin: 0 16px;

  .balance-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0 16px;
  }

  p {
    ${B1}
    text-align: center;
  }
  .balance {
    text-align: center;
    ${HEADER}
  }
`;

export const Wearable = styled.div`
  margin: 0 35px;
  border-radius: 6px;
  margin: 0 16px;
  background-color: #282827;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    aspect-ratio: 1;
  }
`;

export const Footer = styled.div`
  background-color: #282827;
  margin-top: 8px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;

  p {
    ${B1}
  }

  img {
    height: 34px;
    margin-bottom: 8px;
    cursor: pointer;
  }
`;
